'use strict';

import raven from 'raven';
import angular from 'angular';
import Promise from 'bluebird';

import FormController from 'app/controllers/form';
import Config from 'config';
import ClientDataController from '../client-data.controller';
import ClientDataTpl from '../client-data.html';

class GIReceiptController extends FormController {
    /* @ngInject */
    constructor(
        ReceiptsService,
        ClientsService,
        QuotesService,
        EmployeesService,
        GroupInvoicesService,
        Receipt,
        VehiclesService,
        LoopBackAuth,
        $scope, $window, $mdDialog, $mdToast, $state
    ) {
        let receipt = $scope.$parent.$resolve.receipt;
        super(receipt, 'Recibo (remito)', ReceiptsService, null, 'receipts/gi');
        this.user = $scope.$parent.$resolve.user;
        this.client = this.model.client || $scope.$parent.$resolve.client;

        Object.assign(this, {
            ReceiptsService,
            ClientsService,
            QuotesService,
            EmployeesService,
            GroupInvoicesService,
            Receipt,
            VehiclesService,
            LoopBackAuth,
            $scope, $window, $mdDialog, $mdToast, $state
        });
        this.neverEditable = true;

        if (this.user.isAdmin && !this.model.id) {
            this.canChangeEmployee = true;
        }

        this.selectedGroupInvoices = {};
        this.selectedGroupInvoicesAmount = {};
        this.selectedGroupInvoicesComments = {};
        if ($scope.$parent.$resolve.groupInvoice) {
            this.selectedGroupInvoices[
                $scope.$parent.$resolve.groupInvoice.id
            ] = true;
        }
        this.clientGroupInvoices = this.model.id ? this.model.groupInvoices :
            [$scope.$parent.$resolve.groupInvoice]
            .concat($scope.$parent.$resolve.groupInvoices || []);

        // Load GI data if viewing an existing receipt
        if (this.model && this.model.groupInvoices) {
            this.model.groupInvoices.forEach(gi => {
                this.selectedGroupInvoices[gi.id] = true;
                this.selectedGroupInvoicesAmount[gi.id] =
                    gi.receiptGroupInvoices[0].amount;
                this.selectedGroupInvoicesComments[gi.id] =
                    gi.receiptGroupInvoices[0].comments;
            });
        }
    }

    $onInit() {
        super.$onInit();
        this.employee = this.model.employee || this.user.employee;
        this.paymentItems = this.model.paymentItems || [];
        // avoid TypeError: Converting circular structure to JSON
        delete this.model.paymentItems;

        if (!this.model.date) {
            this.model.date = new Date();
        }

        // default canBeCollected: true
        if (!this.model.id) this.model.canBeCollected = true;
        this.updateTotal();
        this.updateTotalPending();
    }


    onPaymentItemChange($event) {
        this.updateTotal();
        this.updateAssociatedAmounts();

        if ($event.attribute && $event.attribute == 'type') {
            if (this.isMissingClientData()) {
                return this.simpleError(`ATENCION: al cliente le faltan datos \
para poder emitir factura. Serán preguntados al momento de guardar este \
recibo`);
            }
        }
    }

    updateTotal() {
        this.total = this.paymentItems.reduce((sum, pi) => {
            return sum + pi.amount;
        }, 0);
        if (isNaN(this.total))
            this.total = 0;
    }

    updateTotalPending() {
    }

    getTotalAssociatedAmounts() {
    }

    isMissingClientData() {
        let missingClientData = !this.client.cuit
            || !this.client.address
            || !this.client.vatType;

        return missingClientData;
    }

    askForMissingClientData() {
        return this.$mdDialog.show({
            controller: ClientDataController,
            template: ClientDataTpl,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                client: this.client
            }
        }).then(data => {
            console.debug(data);
            return this.ClientsService.save(this.client).catch(err => {
                this.simpleError(`No se pudo guardar el cliente`);
                return Promise.reject(err);
            });
        }).catch(err => {
            console.debug(err);
            return Promise.reject(err);
        });
    }


    save() {
        if (this.form.$valid) {
            if (!this.paymentItems.length) {
                return this.simpleError(
                    `Se debe ingresar al menos un valor recibido`
                );
            }

            const totalAssociations = Object.keys(this.selectedGroupInvoices)
                  .reduce((sum, giId) =>
                          sum + this.selectedGroupInvoicesAmount[giId], 0);
            if (this.total != totalAssociations) {
                return this.simpleError(
                    `Monto de imputaciones incorrectas`
                );
            }

            return Promise.resolve().then(() => {
                if (!this.isMissingClientData())
                    return Promise.resolve();

                // Ask for missing client data
                return this.askForMissingClientData();
            }).then(() => {
                // TODO: make sure on server side
                if (this.paymentItems.some(p => p.type == 'bankTx')) {
                    this.model.canBeCollected = false;
                }

                /* TODO: check that payment items amount total is enough
                   to impute all of the selected quotes
                */

                let firstTimeSave = this.model.id ? false : true;
                this.showSpin = true;
                this.model.clientId = this.client.id;
                const groupInvoiceData = Object.keys(this.selectedGroupInvoices)
                      .map((giId) => ({
                          groupInvoiceId: giId,
                          amount: this.selectedGroupInvoicesAmount[giId],
                          comments: this.selectedGroupInvoicesComments[giId]
                      }));
                const opts = {
                    receipt: this.model,
                    paymentItems: this.paymentItems,
                    groupInvoiceData
                };
                console.log(opts);
                return this.ReceiptsService.createForGroupInvoice(opts)
                    .then(data => {
                        Object.assign(this.model, data.receipt);
                        this.updateTotalPending();
                        this.showSpin = false;
                        this.editable = true;
                        this.editing = false;
                        if (firstTimeSave) this.updateLocation();
                    }, err => {
                        console.error(err);
                    });
            }).catch(err => {
                console.error(err);
            });
        } else {
            console.debug(this.form.$valid, this.form);
        }
    }

    queryEmployeeSearch() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchEmployeeText}/i`
                    }
                }
            }
        });
    }

    selectedEmployeeChange(employee) {
        if (employee) {
            this.model.employee = employee;
            this.employee = employee;
        }
    }

    addPaymentItem() {
        let paymentItem = this.ReceiptsService.createPaymentItem({
            receipt: this.model
        });
        this.paymentItems.push(paymentItem);
        this.updateTotal();
        this.updateAssociatedAmounts();
    }

    removePaymentItem($event) {
        let paymentItem = $event.paymentItem;
        let index = this.paymentItems.findIndex(
            p => p.$$hashKey == paymentItem.$$hashKey
        );
        if (index > -1) {
            this.paymentItems.splice(index, 1);
        }
        this.updateTotal();
        this.updateAssociatedAmounts();
    }

    updateAssociatedAmounts() {
    }

    pdf() {
        let url = `${Config.publicUrl}/api/Receipts/pdf?id=${this.model.id}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
        this.$window.open(url);
    }

    getClientName(client) {
        if (client)
            return client.lastName + ' ' + client.name;
    }

    getProceduresDisplay(procedures) {
        if (!procedures) {
            return '';
        }
        return procedures.map(p => p.description).join(', ');
    }

    void(ev) {
        var confirm = this.$mdDialog.prompt()
            .title('Anulación de Recibo')
            .textContent('Ingrese el motivo')
            .placeholder('Motivo de anulación')
            .ariaLabel('Motivo de anulación')
            .required(true)
            .targetEvent(ev)
            .ok('Anular el recibo')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.showVoidSpin = true;
            this.model.$prototype$void({
                reason: result
            }).then(() => {
                this.showVoidSpin = false;
                this.model.deletionReason = result;
                this.model.deletedAt = new Date();
            });
        });
    }


    updateLocation() {
        this.$state.go('editGIReceipt', {id: this.model.id});
    }

    onSelectedGIChange($event) {
        console.log($event);
    }
}

export default GIReceiptController;
